/**
 * Utilitaires partagés pour récupérer des documents du CRM (DRY).
 * Utilisés par la sélection de pièces jointes email ET l'analyse de documents par l'IA.
 *
 * Certains endpoints de téléchargement exigent le JWT en paramètre de requête `?token=`
 * (ex. Documents Cabinet), d'autres acceptent l'en-tête Authorization. Pour être robuste,
 * on ajoute le token en query param ET on envoie l'en-tête Authorization.
 */

const withToken = (url, token) => {
  if (!token) return url;
  return `${url}${url.includes('?') ? '&' : '?'}token=${encodeURIComponent(token)}`;
};

export const buildCrmDocDownloadUrl = (backendUrl, doc, token) => {
  let base;
  switch (doc.source) {
    case 'clients':
      base = `${backendUrl}/api/client/${doc.entityId}/documents/${doc.id}/download`;
      break;
    case 'courtiers':
      base = `${backendUrl}/api/courtier/${doc.entityId}/documents/${doc.id}/download`;
      break;
    case 'companies':
      base = `${backendUrl}/api/admin/contact-directory/companies/${doc.entityId}/documents/${doc.id}/download`;
      break;
    case 'cabinet':
      base = `${backendUrl}/api/admin/cabinet/documents/${doc.id}/download`;
      break;
    default:
      return null;
  }
  return withToken(base, token);
};

/** Télécharge les documents CRM sélectionnés et renvoie une liste d'objets File. */
export const fetchCrmDocsAsFiles = async (backendUrl, authToken, selectedDocs) => {
  const files = [];
  for (const doc of selectedDocs || []) {
    const url = buildCrmDocDownloadUrl(backendUrl, doc, authToken);
    if (!url) continue;
    try {
      const response = await fetch(url, { headers: { Authorization: `Bearer ${authToken}` } });
      if (response.ok) {
        const blob = await response.blob();
        files.push(new File([blob], doc.name, { type: doc.contentType || 'application/octet-stream' }));
      }
    } catch (e) {
      // Téléchargement best-effort : on ignore les documents en échec
    }
  }
  return files;
};
